import { compact } from 'lodash';
import { TableData } from '../../../../../common/generic/content/tables/sortable-table';
import { ImpactChartDataSeries } from '../../../../../common/upright/model/output/scores/net-impact-chart/types';
import { getRenderLegendNameColumnWithColor } from './name-column-with-color';
import { getRenderLegendNetScoreColumn } from './score-column';

export function getTableData(data: ImpactChartDataSeries[], isAbsolute: boolean): TableData {
  const nameColumn = getRenderLegendNameColumnWithColor(data);
  const scoreColumn = getRenderLegendNetScoreColumn(data, isAbsolute);

  const ret: TableData = compact([nameColumn, scoreColumn]);
  return ret;
}
